import { OpenAPI } from '../services/api';
import { OpenAPI as OpenAPIGeocoding } from '../services/api-geocoding';

OpenAPI.WITH_CREDENTIALS = true;
OpenAPI.BASE = process.env.REACT_APP_API_URL || '';

OpenAPIGeocoding.BASE = process.env.REACT_APP_GEOCODING_URL || '';
